import { moduleFactory } from "@/factories/module";
import { resolveItemAppearance } from "@/modules/items/appearance";

export const itemsModule = moduleFactory.create({
  resolveAppearance: resolveItemAppearance,
});
